import { createStore } from 'vuex';
import islandModule from './modules/island';
import baseModule from './modules/base';
import { reactive } from 'vue'; // VueのリアクティブAPIを使用

const store = createStore({
    modules: {
      island: islandModule,
      base: baseModule // baseモジュールを追加
      // baseModule // baseモジュールを追加
    },
    // 以下追加
    state() {
      return {
        islandDetails: reactive({})  // reactiveでオブジェクトをラップ
      };
    },
    mutations: {
      // setIslandData(state,  { islandName, details }) {
      //   state.islandDetails = { ...state.islandDetails, [islandName]: details };  // リアクティブに追加
      // }
      setIslandDetails(state, { islandName, details }) {
        state.islandDetails[islandName] = details;  // islandNameで指定されたプロパティを更新
      }
    },
    actions: {
      async fetchIslandData({ commit }, islandName) {
        try {
          const response = await fetch(`./pub/data/${islandName}.json`);
          if (!response.ok) {
            throw new Error('index.js Failed to fetch data');
          }
          const data = await response.json();
          // commit('setIslandDetails', data);
          commit('setIslandDetails', { islandName, details: data }); // islandNameとdataを一緒にコミット
        } catch (error) {
          console.error('Error fetching island data:', error);
          throw error;
        }
      }
    },
    getters: {
      islandDetails: (state) => state.islandDetails
    }
});
// console.log('store/index.js Vuex store:', store.state); // 追加のログ
export default store;